import FormAntiPassbacks from "../FormAntiPassbacks/FormAntiPassbacks";
import { useLocation, useParams } from "react-router-dom";
import "./CadastroAntiPassbacks.css";
import { useEffect, useState } from "react";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import AntiPassbackService from "../../../services/AntiPassbackService";

const CadastroAntiPassbacks = () => {
	const { antiPassbackId } = useParams();
	const { state } = useLocation();
	const [antiPassback, setAntiPassback] = useState(state);
	const [type, setType] = useState("");

	async function loadAntiPassback(id) {
		const response = await AntiPassbackService.getOneUuid(id);
		if (response.data) {
			setAntiPassback(response.data);
		}
	}

	useEffect(() => {
		setType(antiPassbackId || state ? "edicao" : "cadastro");
		if (state) {
			setAntiPassback(state);
			return;
		}

		if (antiPassbackId) {
			loadAntiPassback(antiPassbackId);
		}
	}, [state, antiPassbackId]);

	return (
		<CadastroContainer>
			<FormAntiPassbacks antiPassback={antiPassback} type={type} />
		</CadastroContainer>
	);
};

export default CadastroAntiPassbacks;
